import { render, staticRenderFns } from "./pagamento-fallito.vue?vue&type=template&id=20632bc7&"
import script from "./pagamento-fallito.vue?vue&type=script&lang=js&"
export * from "./pagamento-fallito.vue?vue&type=script&lang=js&"
import style0 from "./pagamento-fallito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports